/**
 * WikiConnector 专用接口 - 使用原生 axios，绕过项目鉴权拦截器
 * connector 后端是独立服务，不需要项目的 OAuth token
 */
import axios from 'axios'

const BASE_URL = 'https://api-gw.interface003.com'

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  getCredentials: params => http.get('/api/mtbridge/user/credentials', { params }),
  getLicenses: params => http.get('/api/mtbridge/licenses', { params }),
  getSignals: params => http.get('/api/mtbridge/signals', { params }),
  regenerateKey: params => http.post('/api/mtbridge/user/regenerate-key', null, { params })
}
